import React, { useEffect, useRef, useState } from "react";
import { Box, Input, Typography, Skeleton, Grid } from "@mui/material";
import {
  useJsApiLoader,
  GoogleMap,
  DirectionsRenderer,
} from "@react-google-maps/api";

const center = { lat: 11.0168, lng: 76.9558 };
const googleMapsLibraries = ["places"];

function LocationForm(props) {
  const {
    setPickupLocationValue,
    setDropLocationValue,
    isSubmitForm,
    zoomLevel
  } = props;

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyC-z2blVw7iQi4_j8v1rwkf2l5oecEkH54", // Replace with your actual key
    libraries: googleMapsLibraries,
  });

  const [map, setMap] = useState(null);
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [distance, setDistance] = useState("");
  const [duration, setDuration] = useState("");

  const originRef = useRef();
  const destinationRef = useRef();
  const directionsRenderer = useRef(null);

  useEffect(() => {
    if (!isLoaded) return;

    const originAutocomplete = new window.google.maps.places.Autocomplete(
      originRef.current
    );
    const destinationAutocomplete = new window.google.maps.places.Autocomplete(
      destinationRef.current
    );

    originAutocomplete.addListener("place_changed", () => {
      const place = originAutocomplete.getPlace();
      if (place && place.formatted_address) {
        originRef.current.value = place.formatted_address;
        setPickupLocationValue(place.formatted_address);
        calculateRoute()
        // calculateRoute().then((dist) => {
        //   if (dist !== null) {
        //     // setDistanceValue(dist);
        //     sessionStorage.setItem("calculatedDistance", dist); 
        //   }
        // });
        
      }
    });

    destinationAutocomplete.addListener("place_changed", () => {
      const place = destinationAutocomplete.getPlace();
      if (place && place.formatted_address) {
        destinationRef.current.value = place.formatted_address;
        setDropLocationValue(place.formatted_address);
        calculateRoute()
        // calculateRoute().then((dist) => {
        //   if (dist !== null) {
        //     // setDistanceValue(dist);
        //     debugger
        //     sessionStorage.setItem("calculatedDistance", dist); 
        //   }
        // });
        
      }
    });
  }, [isLoaded]);

  function calculateRoute() {
    return new Promise((resolve, reject) => {
      if (!originRef.current.value || !destinationRef.current.value) {
        resolve(null);
        return;
      }
  
      const directionsService = new window.google.maps.DirectionsService();
  
      if (directionsRenderer.current) {
        directionsRenderer.current.setMap(null);
      }
  
      directionsService.route(
        {
          origin: originRef.current.value,
          destination: destinationRef.current.value,
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === "OK") {
            const leg = result.routes[0].legs[0];
  
            // Setup renderer
            directionsRenderer.current = new window.google.maps.DirectionsRenderer();
            directionsRenderer.current.setMap(map);
            directionsRenderer.current.setDirections(result);
  
            // Update state
            setDirectionsResponse(result);
            setDistance(leg.distance.text);
            setDuration(leg.duration.text);
            sessionStorage.setItem("calculatedDistance", leg.distance.text.trim().replace(/,/g, "").replace("km", "").trim()); 
            // resolve(parseFloat(leg.distance.text));
          } else {
            console.error("Directions request failed:", status);
            reject(status);
          }
        }
      );
    });
  }
  
  

  useEffect(() => {
    if (isSubmitForm) {
      clearRoute();
    }
  }, [isSubmitForm]);

  function clearRoute() {
    if (directionsRenderer.current) {
      directionsRenderer.current.setDirections(null);
    }
    setDirectionsResponse(null);
    setDistance("");
    setDuration("");
    if (originRef.current) originRef.current.value = "";
    if (destinationRef.current) destinationRef.current.value = "";
  }

  if (!isLoaded) return <Skeleton variant="text" />;

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "100%",
        }}
      >
        <GoogleMap
          center={center}
          zoom={zoomLevel}
          mapContainerStyle={{ width: "100%", height: "100%" }}
          options={{
            zoomControl: false,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
          }}
          onLoad={(mapInstance) => {
            setMap(mapInstance);
            // directionsRenderer.current =
            //   new window.google.maps.DirectionsRenderer();
            // directionsRenderer.current.setMap(mapInstance);
          }}
        >
          {directionsResponse && (
            <DirectionsRenderer directions={directionsResponse} />
          )}
        </GoogleMap>
      </Box>

      <Box
        sx={{
          padding: 1,
          margin: 1,
          borderRadius: "8px",
          backgroundColor: "white",
          boxShadow: 3,
          // width: "90%",
          zIndex: 1,
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Input placeholder="Origin" inputRef={originRef} fullWidth sx={{
                fontSize: {
                  xs: '12px',
                  lg: '15px'
                }
              }}/>
          </Grid>
          <Grid item xs={6}>
            <Input
              placeholder="Destination"
              inputRef={destinationRef}
              fullWidth
              sx={{
                fontSize: {
                  xs: '12px',
                  lg: '15px'
                }
              }}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} style={{marginTop:{xs:0,md:1}}}>
          <Grid item xs={6}>
            <Typography variant="body1"  sx={{
          fontSize: {
            xs: '12px',
            lg: '13px'
          }
        }}>Distance: {distance}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1"  sx={{
          fontSize: {
            xs: '12px',
            lg: '13px'
          }
        }}>Duration: {duration}</Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default LocationForm;
